import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import Theme from 'components/template/Theme'
import PortalLayout from 'components/layout/PortalLayout'
import PortalViews from 'views/PortalViews'
import affiliatePortalRoutes from 'configs/routes.config/affiliatePortalRoute'
import patientPortalRoutes from 'configs/routes.config/patientPortalRoute'
import AffiliateLogin from 'views/affiliate-portal/Login'
import PatientLogin from 'views/patient-portal/Login'
import useAuth from 'utils/hooks/useAuth'
import { toast, Notification } from 'components/ui'

// Inner component that uses hooks requiring Router context
const PortalContent = ({ type }) => {
    const routes =
        type === 'affiliate' ? affiliatePortalRoutes : patientPortalRoutes
    const { authenticated, userType, signOut } = useAuth()

    // Check for role mismatch and logout
    useEffect(() => {
        if (authenticated && userType !== type) {
            signOut()
            toast.push(
                <Notification
                    title={'Accès non autorisé'}
                    type="danger"
                    duration={3000}
                >
                    Vous n'avez pas accès à ce portail
                </Notification>,
                {
                    placement: 'top-center',
                }
            )
        }
    }, [authenticated, userType, type, signOut])

    // If not authenticated, show login page
    if (!authenticated || userType !== type) {
        return type === 'affiliate' ? <AffiliateLogin /> : <PatientLogin />
    }


    // Show portal dashboard
    return (
        <PortalLayout>
            <PortalViews routes={routes} />
        </PortalLayout>
    )
}

const PortalApp = ({ type }) => {
    return (
        <BrowserRouter>
            <Theme>
                <PortalContent type={type} />
            </Theme>
        </BrowserRouter>
    )
}

export default PortalApp
